import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // ── 主页：PPT视频制作工作台 ──
  {
    path: '/',
    name: 'createPpt',
    component: () => import('../views/createPpt.vue')
  },
  // ── 原首页布局（带侧边导航），移至 /home ──
  {
    path: '/home',
    component: () => import('../views/indexHome.vue'),
    children: [
      {
        path: '',
        redirect: { name: 'myShortVideo' }
      },
      {
        path: 'MyDigitalHuman',
        name: 'MyDigitalHuman',
        component: () => import('../views/MyDigitalHuman.vue')
      },
      {
        path: 'myShortVideo',
        name: 'myShortVideo',
        component: () => import('../views/myShortVideo.vue')
      },
      {
        path: 'realTimeInteraction',
        name: 'realTimeInteraction',
        component: () => import('../views/realTimeInteraction.vue')
      },
      {
        path: 'myCourse',
        name: 'myCourse',
        component: () => import('../views/myCourse.vue')
      },
      {
        path: 'settings',
        name: 'mySet',
        component: () => import('../views/mySet.vue')
      },
      {
        path: 'artificialIntelligence',
        name: 'artificialIntelligence',
        component: () => import('../views/artificialIntelligence.vue')
      },
      {
        path: 'drafts',
        name: 'drafts',
        component: () => import('../views/drafts.vue')
      }
    ]
  },
  {
    path: '/createShortVideo',
    name: 'createShortVideo',
    component: () => import('../views/createShortVideo.vue')
  },
  {
    path: '/paidPackages',
    name: 'paidPackages',
    component: () => import('../views/paidPackages.vue')
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: () => import('../views/resetPassword.vue')
  },
  {
    path: '/liveStreaming',
    name: 'liveStreaming',
    component: () => import('../views/liveStreaming.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
